import theme from '@/theme';
import styled from '@emotion/styled';
import { Button } from '@mui/material';

export const StyledButton = styled(Button)<{ main?: boolean }>`
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    height: 34px;
    text-transform: none;
    border-radius: 8px;
    padding: 7px 8px;
    outline: ${({ main = false, theme }) => (main ? 'none' : '1px solid ' + theme.colors.black[300])};
    background-color: ${({ main = false }) => (main ? theme.colors.primary.main : 'transparent')};
    color: ${theme.colors.secondary.main};
    box-shadow: none;

    &:hover {
        box-shadow: none;
        outline: none;
        background: ${({ main = false }) => (main ? theme.colors.primary.hover : theme.colors.black[300])};
    }
`;
